module.exports = {
    // basic
    'read-all': 'lee todo',
    'company-of-user': 'compañía (usuario)',
    // raw
    'user-company-or-role-type-required': 'Se requiere la selección de Compañía (Usuario) o tipo de rol',
    // template
};
